module.exports = __webpack_public_path__ + "static/media/dodawanie_w_zakresie_30_uzupełnianka.f2cbce68.pdf";